<script setup lang="ts">
import { ref } from 'vue';
import FsumDialog from '@/components/Utilities/FsumDialog.vue';

defineProps<{
    loading: boolean;
}>();

const dialogRef = ref<typeof FsumDialog>();
const title = 'Confirm Deletion';
const message = 'Are you sure you want to delete this item? This cannot be undone.';

</script>
<template>
    <FsumDialog
        ref="dialogRef"
        :title="title"
        :message="message"
        :persistent="false"
        :card-classes="'q-pa-md'"
    >
        <template #actions>
            <q-card-actions align="evenly">
                <q-btn
                    v-close-popup="true"
                    label="Cancel"
                    class="cancel-btn fsum-button-outlined q-mr-xl"
                    no-caps
                    @click="dialogRef?.onDialogCancel"
                />
                <q-btn
                    label="Delete"
                    class="final-delete-btn fsum-button-dark-blue"
                    no-caps
                    :loading="loading"
                    @click="dialogRef?.onDialogOK"
                />
            </q-card-actions>
        </template>
    </FsumDialog>
</template>
<style scoped>
</style>
